import styled from 'styled-components';

const PromotionalImg = (props) => <img {...props} alt={props.alt} />;

export const StyledPromotionalPreviewImg = styled(PromotionalImg)``;
export const StyledPromotionalLogo = styled(PromotionalImg)``;
